import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';

export function initPostHog() {
  if (!POSTHOG_KEY) {
    console.warn('PostHog disabled: REACT_APP_POSTHOG_KEY not set');
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false, // Manual page view tracking via React Router
    capture_pageleave: true,
  });
}

export default posthog;
